import { ConditionEvaluatorContext } from './ConditionEvaluatorContext';
export class ConditionSideEvaluatorContext extends ConditionEvaluatorContext {
    constructor(evaluator) {
        super(evaluator);
        this.evaluator = evaluator;
    }
    get aspect() {
        return this.evaluator.parentEvaluator.context.modifiedAspect || this.evaluator.parentEvaluator.context.aspect;
    }
    get actor() {
        return this.evaluator.parentEvaluator.context.modifiedActor || this.evaluator.parentEvaluator.context.actor;
    }
}
